import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useSellMoneyStore } from '@/store/useSellMoneyStore'
import { useUserStore } from '@/store/useUserStore'
import { useAppPreferencesStore } from '@/store/useAppPreferencesStore'
import type { WalletCurrency } from '@/domain'

interface ResetSellMoneyOnRouteEntryProps {
  currency?: WalletCurrency
}

export const ResetSellMoneyOnRouteEntry: React.FC<
  ResetSellMoneyOnRouteEntryProps
> = ({ currency }) => {
  const location = useLocation()
  const resetSellMoneyStore = useSellMoneyStore(
    (state) => state.resetSellMoneyStore,
  )
  const setFromCurrency = useSellMoneyStore((state) => state.setFromCurrency)
  const setToCurrency = useSellMoneyStore((state) => state.setToCurrency)
  const setCryptoAmount = useSellMoneyStore((state) => state.setCryptoAmount)
  const setFiatAmount = useSellMoneyStore((state) => state.setFiatAmount)

  const wallet = useUserStore((state) => state.wallet)
  const displayCurrency = useAppPreferencesStore(
    (state) => state.displayCurrency,
  )

  useEffect(() => {
    // Reset amounts on route entry using user's displayCurrency
    setCryptoAmount({ amount: '0', code: currency?.code || 'USDT' })
    setFiatAmount({ amount: '0', code: displayCurrency?.isin || 'USD' })

    // Set from currency (the currency being sold)
    if (currency) {
      setFromCurrency(currency)
      setCryptoAmount({ amount: '0', code: currency.code })
    }

    // Set to currency (always USDT)
    if (wallet?.completeCurrencies) {
      const usdtCurrency = wallet.completeCurrencies.find(
        (c) => c.code === 'USDT',
      )
      if (usdtCurrency) {
        setToCurrency(usdtCurrency)
      }
    }
  }, [
    location.pathname,
    currency,
    resetSellMoneyStore,
    setFromCurrency,
    setToCurrency,
    setCryptoAmount,
    setFiatAmount,
    wallet,
    displayCurrency?.isin,
  ])

  return null
}
